export default "__VITE_ASSET__3eea2bd2__"